class ValidationError extends Error {
  constructor(message, errors) {
    super();
    this.name = "ValidationError";
    this.message = message;
    this.errors = errors;
  }
}

export default ValidationError;
